import { createFileRoute, Link } from "@tanstack/react-router";
import { FormattedMessage } from "react-intl";
import MediaPlayer from "@/components/ui/media-player.tsx";
import diaryIntro from "@/assets/audios/Writing-diary-intro.m4a";
import { Button } from "@/components/ui/button.tsx";
import { ExerciseLayout } from "@/components/ui/exercise-layout";

export const Route = createFileRoute(
  "/(content)/adults/exercises/(shared)/diary-adults/"
)({
  component: RouteComponent,
  validateSearch: (search: Record<string, unknown>) => ({
    referrer: search?.referrer as string | undefined,
    referrerGroup: search?.referrerGroup as string | undefined,
  }),
  head: () => ({
    meta: [
      {
        title: "Writing a Diary - HAMD",
      },
    ],
  }),
  beforeLoad: () => ({
    title: "weakness.exercises.diary",
    navbar: {
      showTitle: true,
    },
  }),
});

function RouteComponent() {
  return (
    <ExerciseLayout
      contentClassName="py-7.5 space-y-18"
      actions={
        <Link
          to={"/adults/exercises/diary-adults/exercise-explanation"}
        >
          <Button className="w-full">
            <FormattedMessage id="diary.index.startExercise" />
          </Button>
        </Link>
      }
    >
      <p className="text-small">
        <FormattedMessage id="diary.index.intro" />
      </p>

      <MediaPlayer src={diaryIntro} />
    </ExerciseLayout>
  );
}
